/* ============================================================
   TLC SCROLL EFFECTS — restrained parallax
   ============================================================ */
(function(){
  "use strict";
  if(window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var layers = document.querySelectorAll("[data-tlc-parallax]");
  if(!layers.length) return;

  var ticking = false;
  function update(){
    var vh = window.innerHeight;
    layers.forEach(function(el){
      var speed = parseFloat(el.getAttribute("data-tlc-parallax")) || 0.15;
      var rect = el.getBoundingClientRect();
      var offset = (rect.top + rect.height/2 - vh/2) * speed * -1;
      el.style.transform = "translateY(" + offset.toFixed(1) + "px)";
    });
    ticking = false;
  }
  window.addEventListener("scroll", function(){
    if(!ticking){ requestAnimationFrame(update); ticking = true; }
  }, {passive:true});
  update();
})();
